<div class="tags-input scroller" #wrapper [class.disabled]="disabled" [class.open]="isOpen" (click)="toggleList()">
  <div class="tags-list">
    <div *ngFor="let tag of selected; let i = index; trackBy: trackByItem"
         [ngStyle]="{'background-color': tag.color || '#48b9b2'}"
         class="tag-list-item">
      <span>{{ displayText(tag) }}</span>
      <span class="close" (click)="removeItem(i, $event)">×</span>
    </div>

    <span *ngIf="!selected.length" class="tags-placeholder">{{ options.placeholder || '' }}</span>
  </div>

  <button type="button" class="toggle-btn" [class.open]="isOpen"
          [disabled]="disabled"
          (click)="$event.stopPropagation(); toggleList()"
          tabindex="-1"
          aria-label="Ouvrir la liste">
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
      <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <ng-container *ngIf="isOpen">
    <div class="tags-source" (click)="$event.stopPropagation()">
      <!-- Champ de recherche dédié, séparé de la zone des tags -->
      <div class="tags-search">
        <input #searchInput type="text" [(ngModel)]="searchText"
               (input)="onSearchInput()"
               (keydown)="handleKeyEnter($event)"
               autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"
               placeholder="Rechercher..."
               [disabled]="disabled" />
      </div>

      <div class="tags-source-list">
        <ng-container *ngIf="filteredItems.length || canAddNew(); else empty">
          <div *ngFor="let tag of filteredItems; trackBy: trackByItem" class="tag-source-item" (click)="pickItem(tag)">
            <span class="tag-source-dot" [ngStyle]="{'background-color': tag.color || '#48b9b2'}"></span>
            <span>{{ displayText(tag) }}</span>
          </div>

          <div *ngIf="canAddNew()" class="tag-source-item add-option" (click)="addNewItem()">
            <span>+ Ajouter "{{ searchText }}"</span>
          </div>
        </ng-container>
        <ng-template #empty>
          <span class="tag-source-empty">Aucun résultat</span>
        </ng-template>
      </div>
    </div>
  </ng-container>
</div>